module.exports = __webpack_public_path__ + "img/id_step_01_en@2x.eee92ef2.png";